import PropTypes from 'prop-types';

export const notificationType = PropTypes.shape({
  brand: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
  }),
  date: PropTypes.string,
  isRead: PropTypes.bool,
  publication: PropTypes.shape({
    slug: PropTypes.string,
    title: PropTypes.string,
  }),
  slug: PropTypes.string,
  thumbnail: PropTypes.shape({
    url: PropTypes.string,
  }),
});
